import { useState, useEffect } from 'react'
import { getServiceProductListForTenant } from '../api'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'
import { toast } from '@sales-center/components'

export const useGetServicesForTenantOnMount = () => {
  const dispatch = useAppDispatch()
  const [status, setStatus] = useState<'pending' | 'success' | 'fail'>(
    'pending',
  )

  useEffect(() => {
    let mounted = true

    const execute = async () => {
      try {
        const result = await dispatch(getServiceProductListForTenant())

        if (mounted) {
          if (getServiceProductListForTenant.fulfilled.match(result)) {
            setStatus('success')
          } else {
            setStatus('fail')
            toast.error(`Error loading Services list`)
          }
        }
      } catch (error) {
        if (mounted) {
          setStatus('fail')
        }
      }
    }
    execute()

    return () => {
      mounted = false
    }
  }, [dispatch])

  return status
}
